import styled from 'styled-components';
import { largeMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface TopTriggersHealthAdviceContainerProps {
    isHealthAdvice?: boolean;
}

export const TopTriggersHealthAdviceContainer = styled.div<TopTriggersHealthAdviceContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: auto;

    ${({ isHealthAdvice }) => isHealthAdvice && `
        margin-top: 8px;
    `}

    @media ${largeMediaQuery} {
        margin: 0 10px 0 0;
        height: 325px;
        background: #F9F9F9;
    }
`;

export const AqiSummarySectionAdWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 600px;

    @media ${smallMediaQuery} {
        margin-top: 13px;
        flex-direction: row;
        width: 100%;
        height: 250px;
        justify-content: center;
    }
`;
